export default "__VITE_ASSET__BuihzRpa__"